import styled, { css } from 'styled-components'

export const StyledSelect = styled.div`
  .ant-select-selection {
    min-width: 160px;
  }
`

export const LegendWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, auto);
  align-items: center;
`

export const UpperSection = styled.div`
  display: grid;
  grid-template-columns: minmax(156px, 1fr) auto;
  align-items: center;

  ${({ theme }) => css`
    @media (max-width: ${theme.breakpoints.sm}) {
      grid-template-columns: 1fr;
      grid-gap: ${theme.space.md};

      ${Legend} {
        margin-right: ${theme.space.md};
        margin-left: 0;
      }

      .ant-select,
      .ant-select-selection {
        width: 100%;
      }
    }
  `}
`

export const Legend = styled.div`
  ${({ theme }) => css`
    display: grid;
    gap: ${theme.space.xs};
    grid-template-columns: 20px minmax(0, auto);
    margin-left: ${theme.space.md};
    align-items: center;
    line-height: 1.33;
    letter-spacing: 0.42px;
    font-size: ${theme.fontSize.xxxs};
  `}
`

export const LegendIcon = styled.div`
  height: 20px;
  width: 20px;
  border-radius: ${({ theme }) => theme.radius.sm};
`

export const Session = styled(LegendIcon as any)`
  ${({ theme }) => css`
    background-color: ${theme.palette.purple10};
    border: 1px solid ${theme.palette.purple100};
  `}
`

export const UnavailableTimeSlot = styled(LegendIcon as any)`
  background: repeating-linear-gradient(135deg, #f4f8ff -2px, #f4f8ff 2px, #e6edfd, #e6edfd 5px);
  border: 1px solid #9ab9f9;
`

export const AvailableTimeSlot = styled(LegendIcon as any)`
  background-color: ${({ theme }) => theme.palette.white};
  border: 1px solid #9ab9f9;
`

export const MainContent = styled.div`
  display: grid;
  grid-gap: 20px;
  grid-template-columns: minmax(0, 1fr) auto;
  position: relative;
  box-sizing: initial;
  td {
    vertical-align: middle;
  }

  ${({ theme }) => css`
    @media (max-width: calc(${theme.breakpoints.xl} - 1px)) {
      grid-template-columns: minmax(0, 1fr);
    }
  `}
`

export const LeftContent = styled.div``

export const SideContent = styled.div`
  margin-left: auto;
  ${({ theme }) => css`
    @media (max-width: calc(${theme.breakpoints.xl} - 1px)) {
      margin-left: 0;
      position: sticky;
      bottom: 0;
      z-index: 20;
    }
  `}
`

export const FMIBulkActions = styled.div`
  ${({ theme }) => `
    display: block;

    [data-key='max-alert'] {
      width: calc(100% - 18px);
      margin-top: 12px;
    }

    @media (min-width: ${theme.breakpoints.sm}) {
      display: flex;
      justify-content: space-between;
      align-items: center;

      [data-key='max-alert'] {
        max-width: 233px;
        margin-top: 0;

        span[data-key='icon-IconAlertCircle'] {
          align-self: flex-start;
        }
      }
    }

    @media (min-width: ${theme.breakpoints.xl}) {
      display: none;
    }
  `}
`

export const FMIBulkSelect = styled.div`
  ${({ theme }) => `
    font-size: ${theme.fontSize.sm};
    font-weight: ${theme.fontWeight.bold};
    font-stretch: normal;
    font-style: normal;
    line-height: 1.22;
    letter-spacing: 0.63px;
    display: flex;
    align-items: center;
    background-color: transparent;

    .label {
      display: none;
    }

    @media (min-width: ${theme.breakpoints.sm}) {
      background-color: ${theme.palette.white};
      border-radius: 2px;
      border: 1px solid ${theme.palette.gray60};
      padding: 8px 14px;
      width: calc(100% - 220px);
      margin-right: 10px;
      justify-content: space-between;

      .label {
        display: block;
        margin-right: 14px;
      }

      .ant-select {
        max-width: 176px;
      }
    }
  `}
`

export const FMIBulkAlert = styled.div`
  ${({ theme }) => `
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.23;
    letter-spacing: 0.3px;
    display: flex;

    [data-key='max-alert'] {
      padding: 8px;
      border-radius: 2px;

      span {
        display: flex;

        &:not([data-key='icon-IconAlertCircle']) {
          align-items: flex-start;
          margin-top: 2px;
        }
      }

      span[data-key='icon-IconAlertCircle'] {
        font-size: 14px;
        color: ${theme.palette.warning100};
      }

      .label {
        margin-left: 0px;
      }
    }
  `}
`

export const BulkCalendarWrapper = styled.div`
  display: flex;
`

export const BulkLeftNav = styled.div`
  min-width: 168px;
  margin-right: 6px;
  display: none;

  span[data-key='icon-IconAlertCircle'] {
    align-self: flex-start;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: none;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: none;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    display: none;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    display: block;
  }
`

export const BulkCalendar = styled.div`
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 100%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 100%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    width: 100%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    width: calc(100% - 148px - 14px);
  }
`
